export const orderHeaders = {
  orderNo: {
    name: "orderNo",
    width: 0.25,
  },
  docNumbers: {
    name: "docNumbers",
    width: 0.25,
  },
  organizationName: {
    name: "organization",
    width: 0.4,
  },
  createdByEmail: {
    name: "createdBy",
    width: 0.4,
  },
  requestType: {
    name: "requestType",
    width: 0.3,
  },
  orderStatus: {
    name: "status",
    width: 0.3,
    textAlign: "center",
    justifyContent: "center",
  },
  createdAt: {
    name: "createdAt",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
  customerActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};

export const mdorderHeaders = {
  orderNo: {
    name: "orderNo",
    width: 0.3,
  },
  docNumbers: {
    name: "docNumbers",
    width: 0.25,
  },
  organizationName: {
    name: "organization",
    width: 0.5,
  },
  orderStatus: {
    name: "status",
    width: 0.3,
    textAlign: "center",
  },
  createdAt: {
    name: "createdAt",
    width: 0.4,
    textAlign: "center",
  },
  customerActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};

export const smorderHeaders = {
  orderNo: {
    name: "orderNo",
    width: 0.25,
  },
  docNumbers: {
    name: "docNumbers",
    width: 0.5,
  },
  customerActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};
